import { render, staticRenderFns } from "./TempRole.vue?vue&type=template&id=d3f8a9ea&"
import script from "./TempRole.vue?vue&type=script&lang=js&"
export * from "./TempRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports